import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from 'languages/i18n';

import Home from 'pages/Home';
import Main from 'pages/Main';

import { unregister } from './registerServiceWorker';

ReactDOM.render(
  <I18nextProvider i18n={i18n} >
    <Router basename='/fototeca'>
      <Switch>
        <Redirect exact={true} from='/' to={'/home'} />
        <Route path='/visor' extact={true} component={Main} />
        <Route path='/home' extact={true} component={Home} />
        <Route path='*' exact={true} component={Main} />
      </Switch>
    </Router>
  </I18nextProvider>,
  document.getElementById('root')
);

unregister();
